export default __webpack_public_path__ + "static/media/guia-1-3.dcf96ff6.svg";